<div class="col-12 p-0 mt-1 mb-5 ">
  <form [formGroup]="form" class="p-fluid p-formgrid grid dialog-form">
    <div class="field col-4">
      <label for="timeSlot" class="text-xs ml-3">Time Slot</label>
      <p-dropdown [options]="_timeSlots"
                  [autoDisplayFirst]="false"
                  [pTooltip]="toolTip"
                  appendTo="body"
                  formControlName="timeSlot"
                  id="timeSlot">
      <ng-template pTemplate="selectedItem">
        @if (form.controls.timeSlot.value) {
        <div class="flex align-items-center gap-2">
          <div>{{ form.controls.timeSlot.value.displayTime }}</div>
        </div>
        }
        </ng-template>
        <ng-template let-timeSlot pTemplate="item">
          <div class="flex align-items-center gap-2">
            <div>{{ timeSlot.displayTime }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </form>
</div>
